export default "__VITE_ASSET__YpnIW0Ka__"